module.exports = __webpack_public_path__ + "static/media/country_bd.f53cedae.webp";